module.exports = __webpack_public_path__ + "img/picture_nanjing.6b78a5e6.jpg";